import { StartPage } from "../pages/StartPage";
import { WritePage } from "../pages/WritePage";
import CorrectedPage from "../pages/corrected";
import MyEssays from "../pages/myEssays";
import ThemesPage from "../pages/themes";
import { WaitingEssayPage } from "../pages/waitingEssay";

// O <Template> (baseApp) já é aplicado na rota-pai `redacoes`
// (src/core/routes/index.tsx), que envolve o <Outlet /> destas rotas. Por isso
// as páginas abaixo NÃO devem envolver em <Template> de novo — senão o template
// (MenuBar, faixa da campanha Black etc.) renderiza duas vezes. Mesmo padrão
// dos demais módulos (Favoritos, Disciplinas...).
export const EssayRoutes = [
  {
    path: 'temas',
    element: <ThemesPage />
  },
  {
    path: 'minhas_redacoes',
    element: <MyEssays />
  },
  {
    path: 'start/:themeSlug',
    element: <StartPage />
  },
  {
    path: 'escrevendo/:themeSlug',
    element: <WritePage />
  },
  {
    path: 'correcao/:slug/:tryNumber',
    element: <CorrectedPage />
  },
  {
    path: 'aguardando/:slug',
    element: <WaitingEssayPage />
  }
];
